export default "__VITE_ASSET__Xeb3o6rq__"